document.addEventListener('DOMContentLoaded', function () {
  var footerMenu = document.querySelector('.footer__menu');
  if (!footerMenu) return;

  var thirdLevelParents = footerMenu.querySelectorAll('ul ul ul .menu-item-has-children');
  if (!thirdLevelParents.length) return;

  var slideUp = function (element, duration) {
    if (!element) return;
    element.style.overflow = 'hidden';
    element.style.height = element.scrollHeight + 'px';
    element.offsetHeight;
    element.style.transition = 'height ' + duration + 'ms';
    element.style.height = '0px';
    var onEnd = function () {
      element.style.display = 'none';
      element.style.removeProperty('height');
      element.style.removeProperty('overflow');
      element.style.removeProperty('transition');
      element.removeEventListener('transitionend', onEnd);
    };
    element.addEventListener('transitionend', onEnd);
  };

  var slideDown = function (element, duration) {
    if (!element) return;
    element.style.display = 'block';
    element.style.overflow = 'hidden';
    element.style.height = '0px';
    element.offsetHeight;
    element.style.transition = 'height ' + duration + 'ms';
    element.style.height = element.scrollHeight + 'px';
    var onEnd = function () {
      element.style.removeProperty('height');
      element.style.removeProperty('overflow');
      element.style.removeProperty('transition');
      element.removeEventListener('transitionend', onEnd);
    };
    element.addEventListener('transitionend', onEnd);
  };

  thirdLevelParents.forEach(function (menuItem) {
    menuItem.classList.add('accordion');

    if (!menuItem.querySelector('button.submenu-toggle')) {
      var button = document.createElement('button');
      button.setAttribute('aria-expanded', 'false');
      button.className = 'submenu-toggle';
      button.setAttribute('aria-label', 'Toggle submenu');

      var link = menuItem.querySelector(':scope > a');

      if (link) {
        link.after(button);
      } else {
        menuItem.prepend(button);
      }

      button.addEventListener('click', function (e) {
        e.preventDefault();

        var expanded = button.getAttribute('aria-expanded') === 'true';

        footerMenu
          .querySelectorAll('ul ul ul .menu-item-has-children .submenu-toggle[aria-expanded="true"]')
          .forEach(function (otherButton) {
            if (otherButton === button) return;
            otherButton.setAttribute('aria-expanded', 'false');
            var parent = otherButton.closest('.menu-item-has-children');
            if (!parent) return;
            var otherSubmenu = parent.querySelector(':scope > .sub-menu');
            if (otherSubmenu) {
              slideUp(otherSubmenu, 200);
            }
          });

        var submenu = menuItem.querySelector(':scope > .sub-menu');
        if (!submenu) return;

        if (expanded) {
          button.setAttribute('aria-expanded', 'false');
          slideUp(submenu, 200);
        } else {
          button.setAttribute('aria-expanded', 'true');
          slideDown(submenu, 200);
        }
      });

      if (link) {
        var href = link.getAttribute('href');
        if (!href || href === '#') {
          link.addEventListener('click', function (e) {
            e.preventDefault();
            button.click();
          });
        }
      }
    }
  });
});







(function (H) {
    setTimeout(() => H.className = H.className.replace(/\bno-js\b/, 'js'), 500)
})(document.documentElement)
